import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AdminPanel from "./components/AdminPanel";
import PreviewLayout from "./components/preview/PreviewLayout";
import PreviewForside from "./components/preview/PreviewForside";
import PreviewBelief from "./components/preview/PreviewBelief";
import PreviewCoaching from "./components/preview/PreviewCoaching";
import PreviewUndervisning from "./components/preview/PreviewUndervisning";
import PreviewInspiration from "./components/preview/PreviewInspiration";
import PreviewMennesket from "./components/preview/PreviewMennesket";
import PreviewContact from "./components/preview/PreviewContact";
import GoogleAnalyticsTracker from "./components/GoogleAnalyticsTracker";
import CookieBanner from "./components/CookieBanner";

function App() {
  return (
    <div className="App min-h-screen bg-cream">
      <BrowserRouter>
        <GoogleAnalyticsTracker />
        <CookieBanner />
        <Routes>
          <Route element={<PreviewLayout />}>
            <Route path="/" element={<PreviewForside />} />
            <Route path="/undervisning" element={<PreviewUndervisning />} />
            <Route path="/coaching" element={<PreviewCoaching />} />
            <Route path="/om" element={<PreviewBelief />} />
            <Route path="/referencer" element={<PreviewMennesket />} />
            <Route path="/perspektiver" element={<PreviewInspiration />} />
            <Route path="/kontakt" element={<PreviewContact />} />
          </Route>
          <Route
            path="/admin"
            element={
              <>
                <Navbar />
                <AdminPanel />
                <Footer />
              </>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
